document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".product-reviews.swiper", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    autoHeight: false,
    loop: true,
    speed: 700,
    centeredSlides: true,
    loopAdditionalSlides: 0,
    loopAddBlankSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },

    navigation: {
      nextEl: ".button__reviews--next",
      prevEl: ".button__reviews--prev",
    },
  });
});
